module.exports = __webpack_public_path__ + "static/media/fimage.404c5dc5.svg";